import * as React from 'react';
import { useSelector } from 'react-redux';

import { getDateRangeValue, getRangeValue } from '../../../packages/JsonQuery';
import { ElementInViewport } from '../../common/components/element_in_viewport';
import { OneTwoTripBanner } from '../../components/OneTwoTripBanner';
import { selectOneTwoTripBannerExperimentEnabled } from '../../selectors/experiments';
import { getJsonQuery } from '../../selectors/getJsonQuery';
import { trackBannerClick, trackBannerShow } from './tracking';

const URL =
  'https://cian.onetwotrip.com/?activePage=hotel&isStart=false&utm_source=cian&utm_medium=partner&utm_campaign=listing_middle_banner&636bd81ac76114bf06b41e60=%2F%3Freferrer%3Dcian';

export const OneTwoTripBannerContainer: React.VFC = () => {
  const isOneTwoTripBannerExperimentEnabled = useSelector(selectOneTwoTripBannerExperimentEnabled);

  const jsonQuery = useSelector(getJsonQuery);
  const guests = getRangeValue('beds_count')(jsonQuery)?.gte || 1;
  const { gte: startDate, lt: endDate } = getDateRangeValue('dates')(jsonQuery) || {};

  const url = React.useMemo(() => {
    const startDateQuery = startDate ? `&date_start=${startDate}` : '';
    const endDateQuery = endDate ? `&date_end=${endDate}` : '';
    const guestsQuery = guests ? `&rooms%5B0%5D=${guests}` : '';

    return `${URL}${encodeURIComponent(`${startDateQuery}${endDateQuery}${guestsQuery}`)}`;
  }, [startDate, endDate, guests]);

  if (!isOneTwoTripBannerExperimentEnabled) {
    return null;
  }

  return (
    <ElementInViewport
      onChange={isVisble => {
        if (isVisble) {
          trackBannerShow();
        }
      }}
    >
      <OneTwoTripBanner onClick={trackBannerClick} url={url} />
    </ElementInViewport>
  );
};
